// extracted by mini-css-extract-plugin
export var divider = "Divider-module--divider--176b3";
export var vertical = "Divider-module--vertical--ca417";